import axios from './http'

export const doGetAllInitUserLearnTask = (data) => axios.post('/api/userLearnTask/getAllInitUserLearnTask', data || {});

export const doGetAllFinishUserLearnTask = (data) => axios.post('/api/userLearnTask/getAllFinishUserLearnTask', data || {});

export const doGetSingleUserLearnTaskView = (data) => axios.post('/api/userLearnTask/getSingleUserLearnTaskView', data || {});

export const doFinishLearnTask = (data) => axios.post('/api/userLearnTask/finishLearnTask', data || {});

export const doGetCommits = (data) => axios.post('/api/userLearnTask/getCommits', data || {});

export const doAddComment = (data) => axios.post('/api/userLearnTask/addComment', data || {});

export const doGetAllLearnTask = (data) => axios.post('api/user/getAllLearnTask', data || {});

export const doGetPageUserInfo = (data) => axios.post('api/user/getPageUserInfo', data || {});

export const doModifyUserInfo = (data) => axios.post('api/user/modifyUserInfo', data || {});

export const doChangeLearnTask = (data) => axios.post('api/user/changeLearnTask', data || {});

export const doGetLearnTaskView = (data) => axios.post('api/learnTask/getLearnTaskView', data || {});

export const doDeleteLearnTask = (data) => axios.post('api/learnTask/deleteLearnTask', data || {});

export const doStatisticsUserLearnTask = (data) => axios.post('api/statistics/statisticsUserLearnTask', data || {});

export const doStatisticsUserLearnTaskFromTeacher = (data) => axios.post('api/statistics/statisticsUserLearnTaskFromTeacher', data || {});

export const doStatisticsUserLearnTaskFromUser = (data) => axios.post('api/statistics/statisticsUserLearnTaskFromUser', data || {});

export const doGetNotice = (data) => axios.post('api/notice/get', data || {});

export const doInsertOrUpdateNotice = (data) => axios.post('api/notice/insertOrUpdate', data || {});

export const restLastUserRecord = (data) => axios.post('api/login/restLastUserRecord', data || {});



// WEBPACK FOOTER //
// ./src/utils/server.js